import React from 'react';

import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';
import { WordpressGuideSummaryData } from 'Utilities/wordpress/@types';

import { RoundedSectionType } from '../../../common/RoundedSection/RoundedSection';
import { Guides } from '../../../homepage/Components/Guides/Guides';

type GuidesSectionProps = {
  guides?: readonly WordpressGuideSummaryData[];
  theme?: RoundedSectionType;
  title?: string;
};

export const GuidesSection = ({ guides, theme, title }: GuidesSectionProps) => {
  const onGuidesSectionLoad = (label: string) => LANDING_PAGE_EVENTS.SECTION_LOAD({
    label,
    name: LANDING_PAGE_SECTIONS_NAMES.GUIDES,
  });

  return (
    <Guides guides={guides} onLoad={onGuidesSectionLoad} theme={theme} title={title} />
  );
};
